import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M10 1C5.02571 1 1 5.02525 1 10C1 14.9742 5.02525 19 10 19C14.9743 19 19 14.9747 19 10C19 5.02578 14.9747 1 10 1ZM10 17.7442C5.72985 17.7442 2.25582 14.2702 2.25582 10C2.25582 5.72982 5.72985 2.25582 10 2.25582C14.2701 2.25582 17.7442 5.72982 17.7442 10C17.7442 14.2702 14.2701 17.7442 10 17.7442Z",
			fill: "currentColor"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M10.0002 8.50226C9.4671 8.50226 9.08801 8.7274 9.08801 9.0591V13.5727C9.08801 13.857 9.4671 14.1413 10.0002 14.1413C10.5096 14.1413 10.9242 13.857 10.9242 13.5727V9.05903C10.9242 8.72736 10.5096 8.50226 10.0002 8.50226Z",
			fill: "currentColor"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M10.0002 5.71826C9.45525 5.71826 9.02881 6.1092 9.02881 6.55938C9.02881 7.00959 9.45529 7.41237 10.0002 7.41237C10.5333 7.41237 10.9598 7.00959 10.9598 6.55938C10.9598 6.1092 10.5333 5.71826 10.0002 5.71826Z",
			fill: "currentColor"
		}) }) })
	]
});
export default SvgInfo;
